import { createActionGroup, props } from '@ngrx/store';
import { HelloResults } from '@src/suite/common/data-models/service/hello-results';

export const HelloResultsActions = createActionGroup({
    source: 'Hello Results',
    events: {
        'Process Hello Results': props<{ helloResults: HelloResults }>(),
        'Set Week Day Setting': props<{ dayOfWeek: number }>(),
        'Set Language Settings': props<{ language: string }>(),
    },
});
